module.exports = {"USE":{"Current":1,"Baseline":1},"OVERALL":{"Current":1,"Baseline":1},"ACCESS":{"Current":1,"Baseline":3},"DISPARITY":{"Current":1,"Baseline":1},"medicaid":{"Current":"Yes","Baseline":"Yes"},"LIVES":{"Current":2,"Baseline":2},"QUALITY":{"Current":9,"Baseline":20}}


//////////////////
// WEBPACK FOOTER
// ./src/data/ranking/HI.json
// module id = 302
// module chunks = 143196823979170 184088790168614